import { Box, Button, Flex, Text } from '@chakra-ui/react'
import { FormattedMessage } from 'react-intl'
import messages from './messages'
import { LockIcon } from '@chakra-ui/icons'
import { useAccount } from '../../AccountProvider'
import useAccountSubscription from '../../hooks/useAccountSubscription'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useContactTrigger } from '../../../common/hooks/useContactTrigger'
import InternalStandaloneLayout from '../../../../../components/InternalStandaloneLayout'

export default function AccountFrozen() {
  const navigate = useNavigate()

  const doctorProfile = useAccount()
  const { isPlanExpired, isSuspended } = useAccountSubscription(doctorProfile)

  const { triggerContact } = useContactTrigger()

  // Determine if the account is frozen based on subscription status
  const isAccountFrozen = isPlanExpired || isSuspended

  useEffect(() => {
    if (!isAccountFrozen && !doctorProfile.loading) {
      navigate('/dashboard')
    }
  }, [doctorProfile.loading, isAccountFrozen, navigate])

  return (
    <InternalStandaloneLayout showBrand>
      <Flex justifyContent="center" flexDir="column" gap={5}>
        <Flex
          w="40px"
          h="40px"
          borderRadius="10px"
          bg="red.50"
          align="center"
          justify="center"
          alignSelf="center"
        >
          <LockIcon color="red.600" boxSize={4} />
        </Flex>
        <Box>
          <Text fontSize="2xl" fontWeight="bold" textAlign="center">
            <FormattedMessage {...messages.accountFrozen} />
          </Text>
          <Text color="gray.500" textAlign="center">
            <FormattedMessage {...messages.accountFrozenDescription} />
          </Text>
          <Text color="gray.500" textAlign="center">
            <FormattedMessage {...messages.accountFrozenDescription2} />
          </Text>
        </Box>
        <Button
          colorScheme="gray"
          size="md"
          alignSelf="center"
          onClick={triggerContact}
        >
          <FormattedMessage {...messages.contactUs} />
        </Button>
      </Flex>
    </InternalStandaloneLayout>
  )
}
